module.exports = __webpack_public_path__ + "img/taoyuan-5.3628324b.jpg";